import React, { useEffect, useMemo, useState } from 'react';

import { GetCallCenterCallBackHours } from 'common/helpers/Callus';
import { useHistory } from 'react-router-dom';
import qs from 'qs';
import { getTemplateString } from 'common/helpers/string';
import styles from './RequestCallBackPageData.module.scss';
import PageLink from 'components/PageLink/PageLink';
import { getPathnameFromUrl } from 'common/helpers/resolveHost';
import { getTemplateToken } from 'common/helpers/tokensFormatter';

import PrefixSelect, {
  ICountryPrefix,
} from 'components/PhoneInput/PrefixSelect/PrefixSelect';
import { AddToCalendar } from 'common/helpers/AddToCalendar';
import { ICallBackHoursModel } from 'features/CallBack/types';
import { ICallBackTimeSlots } from 'features/CallBack/types';
import http from 'app/http';
import { useAppSelector } from 'app/hooks';
import { selectCoreSettings } from 'features/content/selectors';
import { isNullOrWhiteSpace } from 'common/helpers/string';
import { getGTMVariables, getGTMVariablesPageView } from 'common/helpers/Gtm';
import TagManager from 'react-gtm-module';
import { SvgIcons } from 'common/consts/svgIcons';
import ScrollToTop from 'components/ScrollToTop/ScrollToTop';
import Icon from 'components/Icon/Icon';
import {
  selectLocalePath,
  selectMasterLanguage,
  selectUser,
} from 'features/core/selectors';

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import RequestCallBackForm from './Components/RequestCallBackForm/RequestCallBackForm';

interface Props {
  Model: any;
  PageData: any;
  LayoutModel?: any;
}

const RequestCallBackPageData = (props: Props) => {
  const { Model, PageData, LayoutModel } = props;
  
  const history = useHistory();   
  const [modelState, setModelState] = useState(Model);
  const [pageDataState, setPageDataState] = useState(PageData);
  const [layoutModelState, setLayoutModelState] = useState(LayoutModel);
  const [firstTimeSlotSectionSelected, setFirstTimeSlotSectionSelected] =
    useState(false);

  const CallBackConfirmedNotice = getTemplateString(
    PageData?.CallBackScheduledText,
  );
  const ScheduleTimeToken = getTemplateToken(modelState?.CallMeBackStartTime);
  
  

  
  const [hourSlots, setHourSlots] = useState<any>([]);
  const siteSettings = useAppSelector(selectCoreSettings);
  

  

  const dayLabelToken = getTemplateToken(
    firstTimeSlotSectionSelected
      ? hourSlots?.CurrentDayTitle == 'Today'
        ? PageData?.TodayLabel
        : hourSlots?.CurrentDayTitle == 'Tomorrow' ?
        PageData?.TomorrowLabel :
        findDayTranslation(hourSlots?.CurrentDayTitle)
      : hourSlots?.NextDayTitle == 'Tomorrow'
      ? PageData?.TomorrowLabel
      : findDayTranslation(hourSlots?.NextDayTitle),
  );

  const mobileNomberToken = getTemplateToken(
    modelState?.FormModel.CountryPrefixCode + modelState?.FormModel.PhoneNumber,
  );

  
  useEffect(() => {
    let hours = GetCallCenterCallBackHours(
      LayoutModel?.CallCenterDaysHours,
      LayoutModel?.CallCenterHolidays,
      LayoutModel?.CallBackTimeSlot,
    ) as ICallBackHoursModel;

    setHourSlots(hours);
  }, []);

  function findDayTranslation(dayValue: string) {
    let dayProp = 'Day_' + dayValue?.toLowerCase() + '_name';
    let dayTranslatedValue =
      siteSettings?.PageData?.SiteSettings?.MarketTranslation?.[dayProp];
    return dayTranslatedValue || dayValue;
  }

  

  
  
  var tagManagerArgs: any;
  useEffect(() => {
    if (modelState?.ShowCallBackConfirmed == true) {
      tagManagerArgs = {
        dataLayer: {
          event: 'request_callback',
          callback_date: modelState?.CallMeBackDate,
          callback_timeslot:
            modelState?.CallMeBackStartTime +
            '-' +
            modelState?.CallMeBackEndTime,
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    }
  }, [modelState?.ShowCallBackConfirmed]);

  useEffect(() => {
    if (LayoutModel != undefined) {
      let userid =
        LayoutModel?.Profiles.length > 0
          ? LayoutModel?.Profiles[0].DebtReference
          : '';
      let isLoggedIn = LayoutModel?.HasProfile;
      let lang = PageData?.Language;
      let env = LayoutModel?.Environment;
      let reg = LayoutModel?.CountryCode;
      getGTMVariables(userid, isLoggedIn, lang, reg, env);
      getGTMVariablesPageView(
        window.document.title,
        window.location.href,
        window.location.pathname,
        userid,
        isLoggedIn,
        lang,
        reg,
        env,
      );
    }
  }, [LayoutModel]);
  
  const LOGO_ICONS_PATH = `${process.env.PUBLIC_URL}/images/logo/`;
  const errorLogo = `${LOGO_ICONS_PATH}/oops.svg`;
  const localePath = useAppSelector(selectLocalePath);

  return (
    <div className={styles.wrapper}>
      {!modelState.ShowCallBackConfirmed && LayoutModel?.EnableCallBackForm && (
        <>
          <div className={styles.container}>
            <div className={styles.heading}>{PageData.Header}</div>

            <div className={styles.section}>
              <div className={styles.maincontainer}>
                <>
                {(modelState?.FormModel?.DisableRecaptcha) ? 
                (<RequestCallBackForm Model={Model} LayoutModel={LayoutModel} PageData = {PageData}
                ModelState = {modelState} LayoutModelState = {layoutModelState} PageDataState = {pageDataState}
                SetLayoutModelState = {setLayoutModelState} SetModelState = {setModelState} SetPageDataState = {setPageDataState}
                SetFirstTimeSlotSectionSelected = {setFirstTimeSlotSectionSelected} FirstTimeSlotSectionSelected = {firstTimeSlotSectionSelected}
                HourSlots = {hourSlots}/>):
                (
              <GoogleReCaptchaProvider reCaptchaKey={Model?.ReCaptchaKey}>
                <RequestCallBackForm Model={Model} LayoutModel={LayoutModel} PageData = {PageData}
                ModelState = {modelState} LayoutModelState = {layoutModelState} PageDataState = {pageDataState}
                SetLayoutModelState = {setLayoutModelState} SetModelState = {setModelState} SetPageDataState = {setPageDataState}
                SetFirstTimeSlotSectionSelected = {setFirstTimeSlotSectionSelected} FirstTimeSlotSectionSelected = {firstTimeSlotSectionSelected}
                HourSlots = {hourSlots}/>
              </GoogleReCaptchaProvider>
              )
              }
                </>
                
              </div>
            </div>
          </div>
          <div className={styles.sectionbottom}>
            <p dangerouslySetInnerHTML={{ __html: PageData.BottomNoteText }} />
          </div>
        </>
      )}

      {modelState.ShowCallBackConfirmed && LayoutModel?.EnableCallBackForm && (
        <>
          <ScrollToTop>
            <div className={styles.container}>
              <div className={styles.heading}>
                {PageData?.CallBackConfirmedLabel}
              </div>
              <div className={styles.section}>
                <div className={styles.maincontainer}>
                  <div className={styles.heading_h3}>
                    {' '}
                    {PageData?.ThankYouLabel}
                  </div>

                  <p
                    className={styles.confirm_text}
                    dangerouslySetInnerHTML={{
                      __html:
                        (CallBackConfirmedNotice &&
                          CallBackConfirmedNotice({
                            ScheduledTime: ScheduleTimeToken,
                            PhoneNumber: mobileNomberToken,
                            Day: dayLabelToken,
                          })) ||
                        '',
                    }}
                  />

                  <div className={styles.buttonbar}>
                    <button
                      className="Button Button-black"
                      onClick={() =>
                        AddToCalendar(
                          modelState?.CallMeBackStartDateTime,
                          modelState?.CallMeBackEndDateTime,
                          PageData?.CalendarTitleMessage,
                          PageData?.CalendarDescriptionMessage
                        )
                      }
                    >
                      {PageData?.AddToCalendarLabel}
                    </button>
                    {/* <PageLink
                  url=""
                  text={PageData?.CancelCallBackLabel}
                  className="Button Button-gray"
                /> */}
                  </div>
                </div>
              </div>
            </div>
          </ScrollToTop>
          <div className={styles.sectionbottom}>
            <p dangerouslySetInnerHTML={{ __html: PageData.BottomNoteText }} />
          </div>
        </>
      )}
      {!LayoutModel?.EnableCallBackForm && (
        <div className={styles.container}>
          <div className={styles.section}>
            <div className={styles.maincontainer}>
              <div className={styles.imageError}>
                <img src={errorLogo} />
              </div>
              <p
                className={styles.errorText}
                dangerouslySetInnerHTML={{
                  __html: PageData.NoAccessToCallbackMessageText,
                }}
              />
              <div className={styles.buttonbar}>
                <PageLink
                  url={localePath}
                  text={PageData?.BackToFrontPageButtonText}
                  className={styles.errorButton}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RequestCallBackPageData;
